import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import MindsetsJsSDK, {
    Checkbox,
    ErrorMessageAction,
    ReloadListAction,
    SuccessMessageAction
} from "mindsets-js-sdk";
import {AddChallengeResourceIdsToSelectionAction} from "../../actions/challenge_actions";

function Row({item, row_number}) {
    const dispatch = useDispatch();
    const selected_challenge_resource_ids = useSelector(state => state.selected_challenge_resource_ids);

    return (
        <tr key={item.id}>
            <td>
                <Checkbox
                    checked={selected_challenge_resource_ids.includes(item.id)}
                    toggle={() => {
                        let array = JSON.parse(JSON.stringify(selected_challenge_resource_ids));
                        if (array.includes(item.id)) {
                            array.splice(array.findIndex(id => id === item.id), 1);
                        } else {
                            array.push(item.id);
                        }
                        dispatch(AddChallengeResourceIdsToSelectionAction(array));
                    }}
                />
            </td>
            <td>{row_number}</td>
            <td>{item.id}</td>
            <td>{item.challenge_code}</td>
            <td>{item.title}</td>
            <td>{item.name}</td>
            <td>{item.quiz}</td>
            <td>
                <div className='d-flex flex-gap-10 flex-wrap'>
                    <Link
                        to={`/challenge_resources/${item.id}`}
                        className='btn btn-primary'
                    >Update</Link>
                    <button onClick={() => {
                        if (confirm('Delete Resource?')) {
                            MindsetsJsSDK().API
                                .delete(`challenge_resources/${item.id}`)
                                .then(() => {
                                    dispatch(SuccessMessageAction('Resource has been deleted'));
                                    dispatch(ReloadListAction(true, 'challenge_resources'));
                                })
                                .catch(error => {
                                    dispatch(ErrorMessageAction(error));
                                    console.error(error);
                                });
                        }
                    }}>
                        <i className='fas fa-trash red'/>
                    </button>
                </div>
            </td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        challenge_code: PropTypes.string.isRequired,
        title: PropTypes.string,
        name: PropTypes.string,
        quiz: PropTypes.string
    }).isRequired,
    row_number: PropTypes.number.isRequired
};

export default Row;
